export default (user) => {
    let username = user && user.full_name ? user.full_name : 'User';
    if (user && user.image) {
        return user.image
    }
    return `https://ui-avatars.com/api/?name=${username}`;
};